import React from "react";
import PropTypes from "prop-types"; // Import PropTypes for prop type validation
import exclamatoryGreen from "../images/exclamatoryGreen.png"; // Update the path as necessary
import closeIconImage from "../images/popup_close.png"; // Import your custom close icon image
import '../styles/AcceptVideoPopup.css'; // Import the CSS file

const AcceptVideoPopup = ({ open, onClose, onApprove }) => {
  if (!open) return null; // Return null if the popup is not open

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <div className="dialog-header">
          <img
            src={closeIconImage}
            alt="Close"
            onClick={onClose}
            className="close-icon"
            aria-label="Close dialog"
          />
        </div>
        <div className="report-problem-section">
          <img
            src={exclamatoryGreen}
            alt="Report Problem"
            className="report-problem-icon"
          />
          <div className="dialog-title">You are about to approve a video</div>
          <p className="dialog-subtitle">
            Are you sure you want to approve this video? This action cannot be undone.
          </p>
        </div>
        <div className="dialog-actions">
          <button onClick={onClose} className="cancel-button">
            Cancel
          </button>
          <button onClick={onApprove} className="approve-button" aria-label="approve video">
            Approve
          </button>
        </div>
      </div>
    </div>
  );
};

// Prop types validation
AcceptVideoPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onApprove: PropTypes.func.isRequired,
};

export default AcceptVideoPopup;
